import './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';
import cx from 'classnames';
import { A as AddIconSvg, D as DownIconSvg, L as LoadingIconSvg, S as SearchIconSvg } from './SearchIcon-835318c0.js';
import { I as IconTickFilledSVG } from './icon-tick-filled-3149e72f.js';

const InputIcon = ({
  icon
}) => {
  const iconRouter = {
    add: /*#__PURE__*/React__default.createElement(AddIconSvg, null),
    select: /*#__PURE__*/React__default.createElement(DownIconSvg, null),
    loading: /*#__PURE__*/React__default.createElement(LoadingIconSvg, null),
    search: /*#__PURE__*/React__default.createElement(SearchIconSvg, null),
    'validate-success': /*#__PURE__*/React__default.createElement(IconTickFilledSVG, null)
  };
  const iconSvg = iconRouter[icon];
  const className = cx('mw-input-icon', `mw-input-icon-${icon}`);
  if (iconSvg) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: className
    }, iconSvg);
  } else {
    return null;
  }
};

export default InputIcon;
